import { en } from '@/i18n/locale/en'
import { ko } from '@/i18n/locale/ko'

export default {
	ko: ko,
	en: en,
}
